<script lang="ts">
  import SidebarEntry from './SidebarEntry.svelte';
  import Fa from 'svelte-fa';
  import { slide } from 'svelte/transition';
  import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
  import { page } from '$app/state';

  import type { MenuEntry } from './Sidebar.Definitions';

  interface Props {
    entry: MenuEntry;
    openState: Map<symbol, boolean>;
    showHpVmware?: boolean;
    level?: number;
  }

  let { entry, openState, showHpVmware, level = 0 }: Props = $props();

  const getIsActive = (currentPath: string, content: MenuEntry['content']): boolean => {
    if ('href' in content) {
      return currentPath === content.href;
    } else {
      return content.children.some((child) => getIsActive(currentPath, child.content));
    }
  };

  let isActive = $derived(getIsActive(page.url.pathname, entry.content));
  let buttonClass = $derived([
    'flex w-full text-left cursor-pointer',
    level === 0 ? 'p-3' : 'p-2',
    isActive
      ? 'text-white'
      : 'text-gray-300 dark:text-gray-400 hover:text-white dark:hover:text-gray-200',
  ]);

  const cascadeToggle = (item: MenuEntry) => {
    if ('children' in item.content) {
      openState.set(item.content.key, false);
      item.content.children.forEach(cascadeToggle);
    }
  };

  const toggleEntry = () => {
    if ('children' in entry.content) {
      openState.set(entry.content.key, !open);

      if (open) {
        entry.content.children.forEach(cascadeToggle);
      }
    }
  };

  let open = $derived('key' in entry.content && openState.get(entry.content.key));
</script>

<li class:hidden={entry.hpVmware && !showHpVmware}>
  {#if 'href' in entry.content}
    <a
      class={buttonClass}
      href={entry.content.href}
      data-sveltekit-preload-data="tap"
      data-sveltekit-reload={entry.reload}
    >
      {#if entry.icon}
        <div class="mr-1 w-6">
          <Fa icon={entry.icon} size="lg" class="mx-auto" />
        </div>
      {/if}
      <span>{entry.title}</span>
    </a>
  {:else}
    <button class={buttonClass} onclick={toggleEntry}>
      {#if entry.icon}
        <div class="mr-1 w-6">
          <Fa icon={entry.icon} size="lg" class="mx-auto" />
        </div>
      {/if}
      <span>{entry.title}</span>
      <Fa icon={faCaretRight} class={`ml-auto transition ${open ? 'rotate-90' : ''}`} />
    </button>
    {#if open}
      <menu class="bg-slate-600 pl-4 dark:bg-slate-800" transition:slide>
        {#each entry.content.children as child}
          <SidebarEntry entry={child} {openState} {showHpVmware} level={level + 1} />
        {/each}
      </menu>
    {/if}
  {/if}
</li>
